import * as z from 'zod'
import type {
  CollectionAggregateRow,
  CollectionKeywordRow,
  CollectionMasterRow,
  CollectionSalesRow,
  SubCollectionRow,
} from '@/api/collectionKeywords/types'

export const collectionMasterRowSchema: z.ZodType<CollectionMasterRow> = z.object({
  collectionId: z.number().int(),
  collectionName: z.string(),
  parentId: z.number().int().nullable(),
  description: z.string().nullable(),
  aiInstructions: z.string().nullable(),
})

export const collectionSalesRowSchema: z.ZodType<CollectionSalesRow> = z.object({
  directCollectionId: z.number().int().nullable(),
  subCollectionId: z.number().int().nullable(),
  sales365: z
    .number()
    .nullable()
    .transform((value) => value ?? 0),
})

export const subCollectionRowSchema: z.ZodType<SubCollectionRow> = z.object({
  subCollectionId: z.number().int(),
  collectionId: z.number().int(),
})

export const collectionAggregateRowSchema: z.ZodType<CollectionAggregateRow> = z.object({
  collectionId: z.number().int(),
  value: z
    .number()
    .nullable()
    .transform((value) => value ?? 0),
})

export const collectionKeywordRowSchema: z.ZodType<CollectionKeywordRow> = z.object({
  collectionId: z.number().int(),
  keyword: z.object({
    keywordId: z.number().int(),
    value: z.string(),
    languageKey: z.string(),
    keywordType: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]),
    isAlias: z.boolean(),
    searchVolumePerMonthAvg: z.number().nullable(),
  }),
})
